// Generated by purs version 0.15.15
import * as API_Util from "../API.Util/index.js";
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Argonaut_Core from "../Data.Argonaut.Core/index.js";
import * as Data_BasicURL from "../Data.BasicURL/index.js";
import * as Data_Bifunctor from "../Data.Bifunctor/index.js";
import * as Data_Codec from "../Data.Codec/index.js";
import * as Data_Codec_Argonaut from "../Data.Codec.Argonaut/index.js";
import * as Data_Codec_Argonaut_Common from "../Data.Codec.Argonaut.Common/index.js";
import * as Data_Codec_Argonaut_Compat from "../Data.Codec.Argonaut.Compat/index.js";
import * as Data_Codec_Argonaut_Record from "../Data.Codec.Argonaut.Record/index.js";
import * as Data_DateTime from "../Data.DateTime/index.js";
import * as Data_DateTime_Parsing from "../Data.DateTime.Parsing/index.js";
import * as Data_Duration from "../Data.Duration/index.js";
import * as Data_Either from "../Data.Either/index.js";
import * as Data_Function from "../Data.Function/index.js";
import * as Data_Functor from "../Data.Functor/index.js";
import * as Data_Generic_Rep from "../Data.Generic.Rep/index.js";
import * as Data_HTTP_Method from "../Data.HTTP.Method/index.js";
import * as Data_Maybe from "../Data.Maybe/index.js";
import * as Data_Monoid from "../Data.Monoid/index.js";
import * as Data_Newtype from "../Data.Newtype/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Data_Show_Generic from "../Data.Show.Generic/index.js";
import * as Data_Time_Duration from "../Data.Time.Duration/index.js";
import * as Parsing from "../Parsing/index.js";
import * as Routing_Duplex from "../Routing.Duplex/index.js";
import * as Visonum_BulkPingApp_Util from "../Visonum.BulkPingApp.Util/index.js";
var showRecord = /* #__PURE__ */ Data_Show.showRecord()();
var pingTimeAvgMillisIsSymbol = {
    reflectSymbol: function () {
        return "pingTimeAvgMillis";
    }
};
var pingTimeMaxMillisIsSymbol = {
    reflectSymbol: function () {
        return "pingTimeMaxMillis";
    }
};
var pingTimeMedianMillisIsSymbol = {
    reflectSymbol: function () {
        return "pingTimeMedianMillis";
    }
};
var pingTimeMinMillisIsSymbol = {
    reflectSymbol: function () {
        return "pingTimeMinMillis";
    }
};
var pingTimeStdDevJitterMillisIsSymbol = {
    reflectSymbol: function () {
        return "pingTimeStdDevJitterMillis";
    }
};
var pingTimeTR143JitterMillisIsSymbol = {
    reflectSymbol: function () {
        return "pingTimeTR143JitterMillis";
    }
};
var timestampIsSymbol = {
    reflectSymbol: function () {
        return "timestamp";
    }
};
var messageIsSymbol = {
    reflectSymbol: function () {
        return "message";
    }
};
var genericShowConstructor = /* #__PURE__ */ Data_Show_Generic.genericShowConstructor(Data_Show_Generic.genericShowArgsNoArguments);
var routeDuplexParams = /* #__PURE__ */ Routing_Duplex.routeDuplexParams();
var buildParamsCons = /* #__PURE__ */ Routing_Duplex.buildParamsCons({
    reflectSymbol: function () {
        return "c";
    }
})()()()();
var jobIdIsSymbol = {
    reflectSymbol: function () {
        return "jobId";
    }
};
var object = /* #__PURE__ */ Data_Codec_Argonaut_Record.object();
var rowListCodecCons = /* #__PURE__ */ Data_Codec_Argonaut_Record.rowListCodecCons(Data_Codec_Argonaut_Record.rowListCodecNil)()();
var composeFlipped1 = /* #__PURE__ */ Data_Codec.composeFlipped(Data_Either.bindEither);
var object1 = /* #__PURE__ */ object(/* #__PURE__ */ rowListCodecCons(jobIdIsSymbol));
var bind = /* #__PURE__ */ Control_Bind.bind(Data_Either.bindEither);
var map = /* #__PURE__ */ Data_Functor.map(Data_Either.functorEither);
var mempty = /* #__PURE__ */ Data_Monoid.mempty(/* #__PURE__ */ Data_Monoid.monoidFn(Data_Monoid.monoidString));
var configIsSymbol = {
    reflectSymbol: function () {
        return "config";
    }
};
var BulkPingSuccess = /* #__PURE__ */ (function () {
    function BulkPingSuccess(value0) {
        this.value0 = value0;
    };
    BulkPingSuccess.create = function (value0) {
        return new BulkPingSuccess(value0);
    };
    return BulkPingSuccess;
})();
var BulkPingError = /* #__PURE__ */ (function () {
    function BulkPingError(value0) {
        this.value0 = value0;
    };
    BulkPingError.create = function (value0) {
        return new BulkPingError(value0);
    };
    return BulkPingError;
})();
var Pending = /* #__PURE__ */ (function () {
    function Pending() {

    };
    Pending.value = new Pending();
    return Pending;
})();
var Running = /* #__PURE__ */ (function () {
    function Running() {

    };
    Running.value = new Running();
    return Running;
})();
var Cancelled = /* #__PURE__ */ (function () {
    function Cancelled() {

    };
    Cancelled.value = new Cancelled();
    return Cancelled;
})();
var Finished = /* #__PURE__ */ (function () {
    function Finished() {

    };
    Finished.value = new Finished();
    return Finished;
})();
var Failed = /* #__PURE__ */ (function () {
    function Failed() {

    };
    Failed.value = new Failed();
    return Failed;
})();
var genericBulkPingResult_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return new BulkPingSuccess(x.value0);
        };
        if (x instanceof Data_Generic_Rep.Inr) {
            return new BulkPingError(x.value0);
        };
        throw new Error("Failed pattern match at Visonum.API.SpeedMaster (line 274, column 1 - line 274, column 41): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof BulkPingSuccess) {
            return new Data_Generic_Rep.Inl(x.value0);
        };
        if (x instanceof BulkPingError) {
            return new Data_Generic_Rep.Inr(x.value0);
        };
        throw new Error("Failed pattern match at Visonum.API.SpeedMaster (line 274, column 1 - line 274, column 41): " + [ x.constructor.name ]);
    }
};
var showBulkPingResult = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericBulkPingResult_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsCons(pingTimeAvgMillisIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(pingTimeMaxMillisIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(pingTimeMedianMillisIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(pingTimeMinMillisIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(pingTimeStdDevJitterMillisIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsCons(pingTimeTR143JitterMillisIsSymbol)(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(timestampIsSymbol)(Data_DateTime.showDateTime))(Data_Duration.showDuration))(Data_Duration.showDuration))(Data_Duration.showDuration))(Data_Duration.showDuration))(Data_Duration.showDuration))(Data_Duration.showDuration))))({
        reflectSymbol: function () {
            return "BulkPingSuccess";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowConstructor(/* #__PURE__ */ Data_Show_Generic.genericShowArgsArgument(/* #__PURE__ */ showRecord(/* #__PURE__ */ Data_Show.showRecordFieldsConsNil(messageIsSymbol)(Data_Show.showString))))({
        reflectSymbol: function () {
            return "BulkPingError";
        }
    })))
};
var genericBulkPingJobStatus_ = {
    to: function (x) {
        if (x instanceof Data_Generic_Rep.Inl) {
            return Pending.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && x.value0 instanceof Data_Generic_Rep.Inl) {
            return Running.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0 instanceof Data_Generic_Rep.Inl)) {
            return Cancelled.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inl))) {
            return Finished.value;
        };
        if (x instanceof Data_Generic_Rep.Inr && (x.value0 instanceof Data_Generic_Rep.Inr && (x.value0.value0 instanceof Data_Generic_Rep.Inr && x.value0.value0.value0 instanceof Data_Generic_Rep.Inr))) {
            return Failed.value;
        };
        throw new Error("Failed pattern match at Visonum.API.SpeedMaster (line 184, column 1 - line 184, column 44): " + [ x.constructor.name ]);
    },
    from: function (x) {
        if (x instanceof Pending) {
            return new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value);
        };
        if (x instanceof Running) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value));
        };
        if (x instanceof Cancelled) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value)));
        };
        if (x instanceof Finished) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inl(Data_Generic_Rep.NoArguments.value))));
        };
        if (x instanceof Failed) {
            return new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(new Data_Generic_Rep.Inr(Data_Generic_Rep.NoArguments.value))));
        };
        throw new Error("Failed pattern match at Visonum.API.SpeedMaster (line 184, column 1 - line 184, column 44): " + [ x.constructor.name ]);
    }
};
var showBulkPingJobStatus = {
    show: /* #__PURE__ */ Data_Show_Generic.genericShow(genericBulkPingJobStatus_)(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Pending";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Running";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Cancelled";
        }
    }))(/* #__PURE__ */ Data_Show_Generic.genericShowSum(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Finished";
        }
    }))(/* #__PURE__ */ genericShowConstructor({
        reflectSymbol: function () {
            return "Failed";
        }
    }))))))
};
var rdBulkPingStatusQuery = /* #__PURE__ */ Routing_Duplex.params(/* #__PURE__ */ routeDuplexParams(/* #__PURE__ */ buildParamsCons(Routing_Duplex.buildParamsNil)))({
    c: Routing_Duplex["int"]
});
var rdBulkPingResultQuery = /* #__PURE__ */ Routing_Duplex.params(/* #__PURE__ */ routeDuplexParams(/* #__PURE__ */ buildParamsCons(/* #__PURE__ */ Routing_Duplex.buildParamsCons(jobIdIsSymbol)()()()()(Routing_Duplex.buildParamsNil))))({
    jobId: Routing_Duplex.string,
    c: Routing_Duplex["int"]
});
var codecObj = /* #__PURE__ */ object(/* #__PURE__ */ Data_Codec_Argonaut_Record.rowListCodecConsOptional(/* #__PURE__ */ rowListCodecCons({
    reflectSymbol: function () {
        return "tag";
    }
}))()()({
    reflectSymbol: function () {
        return "payload";
    }
}))("TaggedObject")({
    tag: Data_Codec_Argonaut.string,
    payload: /* #__PURE__ */ Data_Codec_Argonaut_Record.optional(Data_Codec_Argonaut.json)
});
var codecJobStatus = /* #__PURE__ */ (function () {
    var encode = function (v) {
        if (v instanceof Pending) {
            return "Pending";
        };
        if (v instanceof Running) {
            return "Running";
        };
        if (v instanceof Cancelled) {
            return "Cancelled";
        };
        if (v instanceof Finished) {
            return "Finished";
        };
        if (v instanceof Failed) {
            return "Failed";
        };
        throw new Error("Failed pattern match at Visonum.API.SpeedMaster (line 230, column 14 - line 235, column 25): " + [ v.constructor.name ]);
    };
    var decode = function (v) {
        if (v === "Pending") {
            return new Data_Maybe.Just(Pending.value);
        };
        if (v === "Running") {
            return new Data_Maybe.Just(Running.value);
        };
        if (v === "Cancelled") {
            return new Data_Maybe.Just(Cancelled.value);
        };
        if (v === "Finished") {
            return new Data_Maybe.Just(Finished.value);
        };
        if (v === "Failed") {
            return new Data_Maybe.Just(Failed.value);
        };
        return Data_Maybe.Nothing.value;
    };
    return Data_Codec_Argonaut.prismaticCodec("BulkPingJobStatus")(decode)(encode)(Data_Codec_Argonaut.string);
})();
var codecDurationMillis = /* #__PURE__ */ (function () {
    var encode = (function () {
        var $273 = Data_Newtype.un()(Data_Time_Duration.Milliseconds);
        var $274 = Data_Time_Duration.convertDuration(Data_Duration.durationDuration)(Data_Time_Duration.durationMilliseconds);
        return function ($275) {
            return $273($274($275));
        };
    })();
    var decode = (function () {
        var $276 = Control_Applicative.pure(Data_Either.applicativeEither);
        return function ($277) {
            return $276(Data_Duration.fromMs($277));
        };
    })();
    return composeFlipped1(Data_Codec_Argonaut.number)(Data_Codec.codec(decode)(encode));
})();
var codecDateTime = /* #__PURE__ */ (function () {
    var decode = (function () {
        var $278 = Data_Bifunctor.bimap(Data_Bifunctor.bifunctorEither)(function ($280) {
            return Data_Codec_Argonaut.TypeMismatch.create(Parsing.parseErrorMessage($280));
        })(function (v) {
            return v.value0;
        });
        return function ($279) {
            return $278(Data_DateTime_Parsing.fromString($279));
        };
    })();
    return composeFlipped1(Data_Codec_Argonaut.string)(Data_Codec.codec(decode)(Visonum_BulkPingApp_Util.dateTimeToStringISO8601));
})();
var codecJobStatusEntry = /* #__PURE__ */ object(/* #__PURE__ */ Data_Codec_Argonaut_Record.rowListCodecCons(/* #__PURE__ */ Data_Codec_Argonaut_Record.rowListCodecCons(/* #__PURE__ */ Data_Codec_Argonaut_Record.rowListCodecCons(/* #__PURE__ */ Data_Codec_Argonaut_Record.rowListCodecCons(/* #__PURE__ */ rowListCodecCons({
    reflectSymbol: function () {
        return "status";
    }
}))()()({
    reflectSymbol: function () {
        return "startedAt";
    }
}))()()({
    reflectSymbol: function () {
        return "processedIpCount";
    }
}))()()({
    reflectSymbol: function () {
        return "initialIpCount";
    }
}))()()({
    reflectSymbol: function () {
        return "errorsCount";
    }
}))("BulkPingJobStatusEntry")({
    status: codecJobStatus,
    processedIpCount: Data_Codec_Argonaut["int"],
    initialIpCount: Data_Codec_Argonaut["int"],
    errorsCount: Data_Codec_Argonaut["int"],
    startedAt: codecDateTime
});
var codecBulkPingStatusResponse = /* #__PURE__ */ object(/* #__PURE__ */ rowListCodecCons({
    reflectSymbol: function () {
        return "jobs";
    }
}))("BulkPingStatusResponse")({
    jobs: /* #__PURE__ */ Data_Codec_Argonaut_Common.strMap(codecJobStatusEntry)
});
var getBulkPingStatus = function (baseUrl) {
    return function (token) {
        return function (query) {
            return API_Util.mkClient({
                baseUrl: baseUrl,
                method: Data_HTTP_Method.GET.value,
                path: "v1/vf/bulk-ping/status",
                token: new Data_Maybe.Just(token),
                query: new Data_Maybe.Just(query),
                body: Data_Maybe.Nothing.value,
                encodeBody: Data_Function["const"](Data_Argonaut_Core.jsonNull),
                encodeQuery: Routing_Duplex.print(rdBulkPingStatusQuery),
                decodeResponse: Data_Codec.decode(codecBulkPingStatusResponse)
            });
        };
    };
};
var codecBulkPingStartResponse = /* #__PURE__ */ object1("BulkPingStartResponse")({
    jobId: Data_Codec_Argonaut.string
});
var codecBulkPingResult = /* #__PURE__ */ (function () {
    var codecSuccessFields = object(Data_Codec_Argonaut_Record.rowListCodecCons(Data_Codec_Argonaut_Record.rowListCodecCons(Data_Codec_Argonaut_Record.rowListCodecCons(Data_Codec_Argonaut_Record.rowListCodecCons(Data_Codec_Argonaut_Record.rowListCodecCons(Data_Codec_Argonaut_Record.rowListCodecCons(rowListCodecCons(timestampIsSymbol))()()(pingTimeTR143JitterMillisIsSymbol))()()(pingTimeStdDevJitterMillisIsSymbol))()()(pingTimeMinMillisIsSymbol))()()(pingTimeMedianMillisIsSymbol))()()(pingTimeMaxMillisIsSymbol))()()(pingTimeAvgMillisIsSymbol))("BulkPingSuccess")({
        pingTimeMinMillis: codecDurationMillis,
        pingTimeAvgMillis: codecDurationMillis,
        pingTimeMaxMillis: codecDurationMillis,
        pingTimeStdDevJitterMillis: codecDurationMillis,
        pingTimeTR143JitterMillis: codecDurationMillis,
        pingTimeMedianMillis: codecDurationMillis,
        timestamp: codecDateTime
    });
    var codecErrorFields = object(rowListCodecCons(messageIsSymbol))("BulkPingError")({
        message: Data_Codec_Argonaut.string
    });
    var decode = function (json) {
        return bind(Data_Codec.decode(codecObj)(json))(function (obj) {
            if (obj.tag === "BulkPingSuccess") {
                if (obj.payload instanceof Data_Maybe.Just) {
                    return map(BulkPingSuccess.create)(Data_Codec.decode(codecSuccessFields)(obj.payload.value0));
                };
                if (obj.payload instanceof Data_Maybe.Nothing) {
                    return new Data_Either.Left(new Data_Codec_Argonaut.TypeMismatch("BulkPingResult"));
                };
                throw new Error("Failed pattern match at Visonum.API.SpeedMaster (line 291, column 28 - line 293, column 59): " + [ obj.payload.constructor.name ]);
            };
            if (obj.tag === "BulkPingError") {
                if (obj.payload instanceof Data_Maybe.Just) {
                    return map(BulkPingError.create)(Data_Codec.decode(codecErrorFields)(obj.payload.value0));
                };
                if (obj.payload instanceof Data_Maybe.Nothing) {
                    return new Data_Either.Left(new Data_Codec_Argonaut.TypeMismatch("BulkPingResult"));
                };
                throw new Error("Failed pattern match at Visonum.API.SpeedMaster (line 294, column 26 - line 296, column 59): " + [ obj.payload.constructor.name ]);
            };
            return new Data_Either.Left(new Data_Codec_Argonaut.TypeMismatch("BulkPingResult"));
        });
    };
    var encode = function (v) {
        if (v instanceof BulkPingSuccess) {
            return Data_Codec.encode(codecSuccessFields)(v.value0);
        };
        if (v instanceof BulkPingError) {
            return Data_Codec.encode(codecErrorFields)(v.value0);
        };
        throw new Error("Failed pattern match at Visonum.API.SpeedMaster (line 283, column 12 - line 285, column 52): " + [ v.constructor.name ]);
    };
    return Data_Codec.codec(decode)(encode);
})();
var codecBulkPingEntry = /* #__PURE__ */ object(/* #__PURE__ */ Data_Codec_Argonaut_Record.rowListCodecCons(/* #__PURE__ */ Data_Codec_Argonaut_Record.rowListCodecCons(/* #__PURE__ */ rowListCodecCons({
    reflectSymbol: function () {
        return "timeSyn";
    }
}))()()({
    reflectSymbol: function () {
        return "timeIcmp";
    }
}))()()({
    reflectSymbol: function () {
        return "destination";
    }
}))("BulkPingEntry")({
    destination: Data_Codec_Argonaut.string,
    timeSyn: /* #__PURE__ */ Data_Codec_Argonaut_Compat.maybe(codecBulkPingResult),
    timeIcmp: /* #__PURE__ */ Data_Codec_Argonaut_Compat.maybe(codecBulkPingResult)
});
var codecBulkPingCancelResponse = /* #__PURE__ */ object(Data_Codec_Argonaut_Record.rowListCodecNil)("BulkPingCancelResponse")({});
var codecBulkPingCancelRequest = /* #__PURE__ */ object1("BulkPingCancelRequest")({
    jobId: Data_Codec_Argonaut.string
});
var postBulkPingCancel = function (baseUrl) {
    return function (token) {
        return function (body) {
            return API_Util.mkClient({
                baseUrl: baseUrl,
                method: Data_HTTP_Method.POST.value,
                path: "v1/vf/bulk-ping/cancel",
                token: new Data_Maybe.Just(token),
                query: Data_Maybe.Nothing.value,
                body: new Data_Maybe.Just(body),
                encodeBody: Data_Codec.encode(codecBulkPingCancelRequest),
                decodeResponse: Data_Codec.decode(codecBulkPingCancelResponse),
                encodeQuery: mempty
            });
        };
    };
};
var codecBasicURL = /* #__PURE__ */ (function () {
    var decode = (function () {
        var $281 = Data_Bifunctor.lmap(Data_Bifunctor.bifunctorEither)((function () {
            var $283 = Data_Show.show(Parsing.showParseError);
            return function ($284) {
                return Data_Codec_Argonaut.TypeMismatch.create($283($284));
            };
        })());
        return function ($282) {
            return $281(Data_BasicURL.parse($282));
        };
    })();
    return composeFlipped1(Data_Codec_Argonaut.string)(Data_Codec.codec(decode)(Data_BasicURL.print));
})();
var codecBulkPingConfig = /* #__PURE__ */ object(/* #__PURE__ */ Data_Codec_Argonaut_Record.rowListCodecCons(/* #__PURE__ */ Data_Codec_Argonaut_Record.rowListCodecCons(/* #__PURE__ */ Data_Codec_Argonaut_Record.rowListCodecCons(/* #__PURE__ */ Data_Codec_Argonaut_Record.rowListCodecCons(/* #__PURE__ */ Data_Codec_Argonaut_Record.rowListCodecCons(/* #__PURE__ */ rowListCodecCons({
    reflectSymbol: function () {
        return "useSynToPort";
    }
}))()()({
    reflectSymbol: function () {
        return "useIcmp";
    }
}))()()({
    reflectSymbol: function () {
        return "pingCountPerIp";
    }
}))()()({
    reflectSymbol: function () {
        return "intervalBetweenPingsMillis";
    }
}))()()({
    reflectSymbol: function () {
        return "intervalBetweenIpsMillis";
    }
}))()()({
    reflectSymbol: function () {
        return "agentUrl";
    }
}))("BulkPingConfig")({
    pingCountPerIp: Data_Codec_Argonaut["int"],
    agentUrl: codecBasicURL,
    intervalBetweenPingsMillis: codecDurationMillis,
    intervalBetweenIpsMillis: codecDurationMillis,
    useSynToPort: /* #__PURE__ */ Data_Codec_Argonaut_Compat.maybe(Data_Codec_Argonaut["int"]),
    useIcmp: Data_Codec_Argonaut["boolean"]
});
var codecBulkPingResultResponse = /* #__PURE__ */ object(/* #__PURE__ */ Data_Codec_Argonaut_Record.rowListCodecCons(/* #__PURE__ */ rowListCodecCons({
    reflectSymbol: function () {
        return "results";
    }
}))()()(configIsSymbol))("BulkPingResultResponse")({
    config: codecBulkPingConfig,
    results: /* #__PURE__ */ Data_Codec_Argonaut.array(codecBulkPingEntry)
});
var getBulkPingResult = function (baseUrl) {
    return function (token) {
        return function (query) {
            return API_Util.mkClient({
                baseUrl: baseUrl,
                method: Data_HTTP_Method.GET.value,
                path: "v1/vf/bulk-ping/result",
                token: new Data_Maybe.Just(token),
                query: new Data_Maybe.Just(query),
                body: Data_Maybe.Nothing.value,
                encodeBody: Data_Function["const"](Data_Argonaut_Core.jsonNull),
                encodeQuery: Routing_Duplex.print(rdBulkPingResultQuery),
                decodeResponse: Data_Codec.decode(codecBulkPingResultResponse)
            });
        };
    };
};
var codecBulkPingStartRequest = /* #__PURE__ */ object(/* #__PURE__ */ Data_Codec_Argonaut_Record.rowListCodecCons(/* #__PURE__ */ rowListCodecCons({
    reflectSymbol: function () {
        return "destinationIps";
    }
}))()()(configIsSymbol))("BulkPingStartRequest")({
    destinationIps: /* #__PURE__ */ Data_Codec_Argonaut.array(Data_Codec_Argonaut.string),
    config: codecBulkPingConfig
});
var postBulkPingStart = function (baseUrl) {
    return function (token) {
        return function (body) {
            return API_Util.mkClient({
                baseUrl: baseUrl,
                method: Data_HTTP_Method.POST.value,
                path: "v1/vf/bulk-ping/start",
                token: new Data_Maybe.Just(token),
                query: Data_Maybe.Nothing.value,
                body: new Data_Maybe.Just(body),
                encodeBody: Data_Codec.encode(codecBulkPingStartRequest),
                decodeResponse: Data_Codec.decode(codecBulkPingStartResponse),
                encodeQuery: mempty
            });
        };
    };
};
export {
    Pending,
    Running,
    Cancelled,
    Finished,
    Failed,
    BulkPingSuccess,
    BulkPingError,
    codecBulkPingResultResponse,
    codecBulkPingStartRequest,
    codecBulkPingStatusResponse,
    codecJobStatusEntry,
    getBulkPingResult,
    getBulkPingStatus,
    postBulkPingCancel,
    postBulkPingStart,
    genericBulkPingJobStatus_,
    showBulkPingJobStatus,
    genericBulkPingResult_,
    showBulkPingResult
};
//# sourceMappingURL=index.js.map
